<template>
  <div fluid :style="{'padding-left':'0px', 'padding-right':'0px'}">
    <v-card tile ref="main_container" :style="{'min-height': `${display.main.height}px`, 'display': 'flex'}">
      <div style="min-width: 175px;">
        <div fluid :style="{'position': 'relative', 'align-items': 'center'}" >
          <v-btn :style="{float: 'left', visibility: (sequence_view_curtree_to_display == TreeToDisplay.BEFORE ? 'hidden' : 'visible')}" @click="set_sequence_view_curtree_to_display(TreeToDisplay.BEFORE)" id="showBeforeBtn">Show Before</v-btn>
          <div :style="{float: 'left', alignItems: 'center', display: (sequence_view_zoomed_nodes_ids[0] > 0 && sequence_view_curtree_to_display==TreeToDisplay.BEFORE) ? 'flex' : 'none'}">
            <span>View zoomed on </span>
            <span style="display: flex; height: max-content;" id="zoomInfo_before">
              <span v-for="(item, index) in this.zoom_node_parents_before" :key='index' class="zoomInSpan" :style="{ background: color_map[item] || color_map.default, color:is_color_dark[item] ? 'white' : 'black'}">{{item}}</span>
            </span>
          </div>
          <div :style="{float: 'right', alignItems: 'center', display: sequence_view_curtree_to_display==TreeToDisplay.BEFORE ? 'flex' : 'none'}" id="alignSeq_before">
            <span>Sequences leading to the alignment</span>
            <span style="display: flex; height: max-content;" id="select_before">
                <span v-for="(item, index) in align_sequence" :key='index' class="selectSpan" :style="{ background: color_map[item] || color_map.default, color:is_color_dark[item] ? 'white' : 'black'}">{{item}}</span>
            </span>
            <span :style="{display: align_sequence_by >= 0 ? 'block': 'none'}">
              <sup>{{align_sequence_by+1}}</sup>
            </span>
            <span :style="{display: align_sequence_by < 0 ? 'block': 'none'}">
              (last)
            </span>
          </div>
        </div>
        <svg  ref="view_before" :width="Math.max(display.main.width-175,0)" :height="display.main.height" v-show="sequence_view_curtree_to_display==TreeToDisplay.BEFORE">
          <g class="content" :transform="`translate(${display.main.padding.left}, ${display.main.padding.top})`" :width="display.main.innerWidth-175"></g>
          <text class="axis-text axis--x-text" text-anchor="start" :transform="`translate(${display.main.padding.left}, ${display.main.padding.top+ display.main.innerHeight - 5})`">Sum of averages of the treatments (days)</text>
          <g class="axis axis--x" :transform="`translate(${display.main.padding.left}, ${ (display.main.height - display.main.padding.bottom) +1})`"></g>
        </svg>
      </div>
      <div style="min-width: 175px; align-items: center;">
        <div fluid :style="{'position': 'relative', 'right': '0px'}" >
          <v-btn :style="{float: 'right', visibility: (sequence_view_curtree_to_display == TreeToDisplay.AFTER ? 'hidden' : 'visible')}" @click="set_sequence_view_curtree_to_display(TreeToDisplay.AFTER)" id="showAfterBtn">Show After</v-btn>
          <div :style="{float: 'right', alignItems: 'center', display: sequence_view_curtree_to_display==TreeToDisplay.AFTER ? 'flex' : 'none'}" id="alignSeq_after">
            <span>Sequences following the alignment</span>
            <span style="display: flex; height: max-content;" id="select_after">
                <span v-for="(item, index) in align_sequence" :key='index' :style="{ background: color_map[item] || color_map.default, color:is_color_dark[item] ? 'white' : 'black'}" class="selectSpan">{{item}}</span>
            </span>
            <span :style="{display: align_sequence_by >= 0 ? 'block': 'none'}">
              <sup>{{align_sequence_by+1}}</sup>
            </span>
            <span :style="{display: align_sequence_by < 0 ? 'block': 'none'}">
              (last)
            </span>
          </div>
        </div>
        <div :style="{float: 'left', alignItems: 'center', display: (sequence_view_zoomed_nodes_ids[1] > 0 && sequence_view_curtree_to_display==TreeToDisplay.AFTER) ? 'flex' : 'none', paddingLeft: display.main.padding.left+'px'}">
          <span>View zoomed on </span>
          <span style="display: flex; height: max-content;" id="zoomInfo_after">
            <span v-for="(item, index) in zoom_node_parents_after" :key='index' :style="{ float: 'right', width: 'max-content', height: 'max-content',  background: color_map[item] || color_map.default, color:is_color_dark[item] ? 'white' : 'black'}" class="zoomInSpan">{{item}}</span>
          </span>
        </div>
        <svg  ref="view_after" :width="Math.max(display.main.width-175,0)" :height="display.main.height" v-show="sequence_view_curtree_to_display==TreeToDisplay.AFTER">
          <g class="content"  :transform="`translate(${display.main.padding.left}, ${display.main.padding.top})`" :width="display.main.innerWidth-175"></g>
          <text class="axis-text axis--x-text" text-anchor="end" :transform="`translate(${display.main.padding.left + display.main.innerWidth-175}, ${display.main.padding.top+ display.main.innerHeight - 5})`">Sum of averages of the treatments (days)</text>
          <g class="axis axis--x" :transform="`translate(${display.main.padding.left}, ${ (display.main.height - display.main.padding.bottom) +1})`"></g>
        </svg>
      </div>
      <div ref="tooltip"></div>
    </v-card>
  </div>
</template>

<script>

import * as d3 from "d3"
import { mapMutations, mapActions, mapGetters } from "vuex"
import { ViewType, TreeToDisplay }  from "../Config"
import { drawtree }  from "./DrawTree"
import * as treeUtils from "@/treeUtils"
import * as tooltip from "./Tooltip"

/** \brief  This component is the SequenceView displaying the sequences of events from an aligned sequence. This component shows both the "past" events leading to the aligned sequence, and the "events to come" from the aligned_sequence.  */
export default {
  data: () => ({
    TreeToDisplay    : TreeToDisplay,
    selected         : null,
    curtreeBefore    : null,
    curtreeAfter     : null,
    zoom_node_parents_before : [],
    zoom_node_parents_after  : [],
  }),
  watch: {
    tree(data) {
      if(this.sequence_view_zoomed_nodes_ids[0] >= 0)
        this.updateCurtreeBefore();
      if(this.sequence_view_zoomed_nodes_ids[1] >= 0)
        this.updateCurtreeAfter();
      this.draw(data)
    },
    display_flag() {
      if (this.tree) this.draw(this.tree)
    },
    view_type() {
      this.draw(this.tree)
    },
    sequence_view_curtree_to_display() {
      this.draw(this.tree)
    },
    sequence_view_zoomed_nodes_ids() {
      this.updateCurtreeBefore();
      this.updateCurtreeAfter();
      this.draw(this.tree);
    },
  },
  computed: {
    ...mapGetters(['view_type', 'tree', 'color_map', 'display', 'display_flag', 'align_sequence', 'align_sequence_by', 'is_color_dark', 'sequence_view_zoomed_nodes_ids', 'sequence_view_curtree_to_display']),
  },
  mounted() {
    const tooltipDiv = d3.select(this.$refs.tooltip);
    tooltip.reinit(tooltipDiv);

    d3.select(this.$refs.view_before).on("dblclick", (_e, _d) => {
      if(this.sequence_view_zoomed_nodes_ids[0] == -1)
        return;
      this.set_sequence_view_zoomed_nodes_ids({ids: [-1, this.sequence_view_zoomed_nodes_ids[1]]});
      this.draw(this.tree);
    });

    d3.select(this.$refs.view_after).on("dblclick", (_e, _d) => {
      if(this.sequence_view_zoomed_nodes_ids[1] == -1)
        return;
      this.set_sequence_view_zoomed_nodes_ids({ids: [this.sequence_view_zoomed_nodes_ids[0], -1]});
      this.draw(this.tree);
    });

    this.draw(this.tree);
  },
  methods: {
    ...mapActions(['get_distribution', 'set_sequence_view_zoomed_nodes_ids']),
    ...mapMutations(['set_tab', 'set_current_sequence', 'set_sequence_view_curtree_to_display']),

    /** \brief  Draw the tree of the sequences. This function renders either the "Before" or the "After" tree depending on which view the user is in
    * \param treedata the data to render. This tree should contain the "dual_sequence" node, itself containing before the "before" and "after" nodes. */
    draw(treedata) {
      if(!treedata || this.view_type != ViewType.SEQUENCE_VIEW_TYPE)
        return;

      if(this.sequence_view_curtree_to_display == TreeToDisplay.BEFORE)
      {
        let beforetree = treedata.children.length > 0 ? treedata.children[0].children[1] : null;
        drawtree(this, this.$refs, beforetree, (this.curtreeBefore == null ? beforetree : this.curtreeBefore), this.display.main.innerWidth-175, false, "view_before", this.zoomInBefore, "events");
      }
      else
      {
        let aftertree  = treedata.children.length > 0 ? treedata.children[0].children[0] : null;
        drawtree(this, this.$refs, aftertree, (this.curtreeAfter == null ? aftertree : this.curtreeAfter),  this.display.main.innerWidth-175, true,  "view_after", this.zoomInAfter, "events");
      }
    },

    /** \brief  Update the rendering of what node the user has zoomed in in the "Before" tree*/
    updateCurtreeBefore() {
      let beforetree = this.tree.children.length > 0 ? this.tree.children[0].children[1] : null;
      this.curtreeBefore = treeUtils.searchNodeByID(this.tree, this.sequence_view_zoomed_nodes_ids[0]);

      if(beforetree == null || this.curtreeBefore == null)
        this.zoom_node_parents_before = [];
      else
        this.zoom_node_parents_before = this.computePrefix(beforetree, this.curtreeBefore);
    },

    /** \brief  Update the rendering of what node the user has zoomed in in the "After" tree*/
    updateCurtreeAfter() {
      let aftertree     = this.tree.children.length > 0 ? this.tree.children[0].children[0] : null;
      this.curtreeAfter = treeUtils.searchNodeByID(this.tree, this.sequence_view_zoomed_nodes_ids[1]);

      if(aftertree == null || this.curtreeAfter == null)
        this.zoom_node_parents_after = [];
      else
        this.zoom_node_parents_after = this.computePrefix(aftertree, this.curtreeAfter);
    },

    /** \brief  Compute the prefix (i.e., the whole sequence that leads to this node) of a node starting from curtree (as given by, e.g., drawtree). Pay attention that since we are in the aligned mode, the "prefix that leads to this node" has no "absolute" beginning. 
    * \param curtree the root of the tree
    * \param node the node to compute the prefix from. The algorithm stops at curtree
    * \return an array containing the whole sequence leading to node, node included. This function pays attention on whether curtree is a "before" or an "after" event, from which the prefix is correctly rearranged (compared to what is display)*/
    computePrefix(curtree, node) {
      let parents = [...treeUtils.getParents(curtree, node), node];
      let prefix = new Array();
      for(let i = parents.length-1; i > 0; i--) { //avoid curtree
        if(curtree.name == "before")
          prefix.push(parents[i].name);
        else
          prefix = [parents[i].name].concat(prefix);
      }
      return prefix;
    },

    /** \brief  Called by "drawtree" when the user wants to zoomIn a node in the "Before" tree
    * \param tree the node to which the user wants to zoom in. This node should have, for one of its parent, the "before" tree. */
    zoomInBefore(tree) {
      this.set_sequence_view_zoomed_nodes_ids({ids: [tree.id, this.sequence_view_zoomed_nodes_ids[1]]});
    },

    /** \brief  Called by "drawtree" when the user wants to zoomIn a node in the "After" tree
    * \param tree the node to which the user wants to zoom in. This node should have, for one of its parent, the "before" tree. */
    zoomInAfter(tree) {
      this.set_sequence_view_zoomed_nodes_ids({ids: [this.sequence_view_zoomed_nodes_ids[0], tree.id]});
    },

    /** \brief  Function called when the user clicks on a node. This updates the "rendered prefix" to let the user know on what "sequence" he/she has clicked on
    * \param curtree the root of the tree
    * \param node the node selected */
    updatenodeprefix(curtree, node) {
      this.set_current_sequence(this.computePrefix(curtree, node));
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
rect:hover {
  fill-opacity: 0.75;
  cursor: pointer;
}
.axis-text{
  font-size: 0.7em;
}
.selectedNode{
  stroke: black;
  stroke-width: 2;
}
.selectSpan {
  float: right;
  width: max-content;
  height: max-content;
}
.zoomInSpan {
  float: right;
  width: max-content;
  height: max-content;
}
</style>
